export default () => {
  return {
    isLoadingPrograms: false,
    programs: [],
    deletedPrograms: [],

    cachedGroupPrograms: {},

    currentFolderPath: [],

    isLoadingProgramTemplates: false,
    programTemplatesLoaded: false,
    programTemplates: [],
  };
};
